import { useState, useEffect } from "react";
import axios from "axios";
const API = "https://erp-xe9u.onrender.com/api";

export default function ProspectsAnalytics() {
  const [analytics, setAnalytics] = useState(null);
  const [timeRange, setTimeRange] = useState("year");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAnalytics = async () => {
      setLoading(true);
      setError("");
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("No authentication token found");
        }
        const response = await axios.get(
          `${API}/prospects/analytics?timeRange=${timeRange}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        setAnalytics(response.data.analytics);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Failed to fetch analytics. Please try again.",
        );
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [timeRange]);

  if (loading)
    return (
      <div className="text-center py-4 text-gray-300">Loading analytics...</div>
    );
  if (error)
    return <div className="text-red-600 text-center py-4">{error}</div>;
  if (!analytics)
    return (
      <div className="text-gray-300 text-center py-4">
        No analytics available
      </div>
    );

  return (
    <div className="bg-gray-700 p-6 rounded-lg shadow-lg">
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-400 mb-2">
          Time Range
        </label>
        <select
          value={timeRange}
          onChange={(e) => setTimeRange(e.target.value)}
          className="rounded-md bg-gray-700 border-gray-600 text-gray-200 focus:border-orange-500 focus:ring-orange-500 sm:text-sm"
        >
          <option value="month">This Month</option>
          <option value="year">This Year</option>
        </select>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
        <div className="bg-gray-800 p-4 rounded-lg">
          <p className="text-gray-400 text-sm font-medium">Total Prospects</p>
          <p className="text-3xl font-bold text-orange-400 mt-2">
            {analytics.totalProspects}
          </p>
        </div>
        <div className="bg-gray-800 p-4 rounded-lg">
          <p className="text-gray-400 text-sm font-medium">Prospecting</p>
          <p className="text-3xl font-bold text-yellow-400 mt-2">
            {analytics.prospectingCount}
          </p>
        </div>
        <div className="bg-gray-800 p-4 rounded-lg">
          <p className="text-gray-400 text-sm font-medium">Converted to Lead</p>
          <p className="text-3xl font-bold text-green-400 mt-2">
            {analytics.wonCount}
          </p>
        </div>
        <div className="bg-gray-800 p-4 rounded-lg">
          <p className="text-gray-400 text-sm font-medium">Lost</p>
          <p className="text-3xl font-bold text-red-400 mt-2">
            {analytics.lostCount}
          </p>
        </div>
      </div>

      <div className="mt-6 bg-gray-800 p-4 rounded-lg">
        <p className="text-gray-400 text-sm font-medium">Conversion Rate</p>
        <p className="text-3xl font-bold text-purple-400 mt-2">
          {analytics.conversionRate}%
        </p>
        <div className="mt-3 w-full bg-gray-700 rounded-full h-2">
          <div
            className="bg-purple-400 h-2 rounded-full"
            style={{ width: `${Math.min(analytics.conversionRate, 100)}%` }}
          />
        </div>
      </div>

      <div className="mt-6">
        <p className="text-gray-400 text-sm font-medium mb-2">
          Period: {analytics.startDate.split("T")[0]} to{" "}
          {analytics.endDate.split("T")[0]}
        </p>
      </div>
    </div>
  );
}
